import { z } from 'zod';
import { id } from '@/schemas/API/common/atomic/id';
import { date } from '@/schemas/API/common/atomic/date';
import { addressSchema } from '@/schemas/API/common/basic/address';
import { pageableSchema } from '@/schemas/API/GET/pageable/response';
import { sex } from '@/schemas/API/common/atomic/sex';
import { phone } from '@/schemas/API/common/atomic/phone';
import { email } from '@/schemas/API/common/atomic/email';
import { emergencyContactSchema } from '@/schemas/API/common/basic/emergencyContact';
import { tagSchema } from '@/schemas/API/common/basic/tag';
import { carePlanSchema } from '@/schemas/API/GET/client/carePlan/response';

const clientSchema = z.object({
  id,
  firstName: z.string(),
  lastName: z.string(),
  permAddress: addressSchema,
  active: z.boolean(),
  age: z.number(),
  birthdate: date,
  sex,
  closestNextRevDate: date.nullable(),
  carePlans: z.array(carePlanSchema),
});

const clientsSchema = z
  .object({
    content: z.array(clientSchema),
  })
  .merge(pageableSchema);

export const clientDetailedSchema = z.object({
  id: z.number(),
  firstName: z
    .string()
    .min(2, { message: 'Jméno musí být dlouhé aspoň 2 znaky' }),
  lastName: z
    .string()
    .min(2, { message: 'Příjmení musí být dlouhé aspoň 2 znaky' }),
  title: z.string().nullable(),
  sex,
  birthdate: date,
  phone: phone.optional(),
  email: email.optional(),
  active: z.boolean(),
  contacts: z.array(emergencyContactSchema),
  servAddress: addressSchema,
  permAddress: addressSchema,
  carePlans: z.array(carePlanSchema),
  tags: z.array(tagSchema),
});

export type Client = z.infer<typeof clientSchema>;
export type Clients = z.infer<typeof clientsSchema>;
export type ClientDetailed = z.infer<typeof clientDetailedSchema>;
